<script lang="ts" setup>
import { useAccessToApp } from '@autobid/ui/composables/useAccessToApp'
import { pageTransitionMiddleware } from '@autobid/ui/utils/car/pageTransitionMiddleware'

definePageMeta({
  layout: 'strapi',
  pageTransition: {
    mode: 'out-in',
  },
  middleware(to, from) {
    pageTransitionMiddleware(to, from, 'details')
  },
})

const { hasAccess } = useAccessToApp()
</script>

<template>
  <SectionsAuctionDetailsPage v-if="hasAccess" />
</template>
